import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Button } from '@material-ui/core'
import { COLORES } from '../../../../../config/colores'
import * as actions from '../../../actions'
import PrinterPicker from '../../../../Printer/containers/PrinterPicker'
import CamposIngresoCompleto0 from '../../../components/iCompleto/CamposIngresoCompleto0'
import { FORM_INGRESO_COMPLETO } from '../../../../../config/forms'

function IngresoCompleto0 (props) {
  const { onSubmit, iCompletoImpresora, iCompletoImpresoraNombre } = props
  const [seconds, setSeconds] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0 && loading) {
        clearInterval(interval)
        setLoading(false)
      }
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  const selectPrinter = (printer, printerName) => {
    props.selectPrinter(printer, printerName)
  }

  const onPrinterChange = () => {
    props.resetPrinter()
  }

  const handleInputChange = (e) => {
    if (!isNaN(e.target.value) && String(e.target.value).length === 12) {
      props.completoupdateCpa(e.target.value)
      process.nextTick(onSubmit)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    setSeconds(2)
    onSubmit()
  }

  return (
    <div className='completo_busqueda_cpa'>
      <PrinterPicker
        onSubmit={selectPrinter}
        place='icompleto'
        name='printerICompleto'
        show={iCompletoImpresora == null}
      />

      <CamposIngresoCompleto0
        onPrinterChange={onPrinterChange}
        handleSubmit={handleSubmit}
        printerName={iCompletoImpresoraNombre}
        onChange={handleInputChange}
        loading={loading}
      />
      <Button
        variant='contained'
        size='medium'
        onClick={handleSubmit}
        style={{ margin: '2% auto', backgroundColor: COLORES.grey.dark, color: 'white' }}
        disabled={props.invalid}
      >
        Siguiente
      </Button>
    </div>
  )
}

const mapStateToProps = (state) => ({
  iCompletoImpresora: state.camionesIngreso.iCompletoImpresora,
  iCompletoImpresoraNombre: state.camionesIngreso.iCompletoImpresoraNombre,
  invalid: isInvalid(FORM_INGRESO_COMPLETO)(state),
  iCompletoCpaTextValue: state.camionesIngreso.iCompletoCpaTextValue
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_INGRESO_COMPLETO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(IngresoCompleto0))
